import React, { useEffect, useState } from 'react';
import {
  Alert,
  Card,
  Col,
  Form,
  Modal,
  notification,
  Row,
  Spin,
  Switch,
  Tabs,
} from 'antd';
import { useQuery } from 'react-query';

import Check from './Check';
import Consequences from './Consequences';
import {
  getTaskCheckEntity,
  getTaskConseqEntity,
  getTaskStepEntity,
  ProcTaskInit,
} from 'services/workflow';

import TabCancelProposal from './tabCancelProposal';
import tabRejectPayment from './tabRejectPayment';
import tabDocument from './tabDocument';
import TabUpdateAssetRegistrationData from './tabUpdateAssetRegistrationData';
import TabContractRescheduling from './tabContractRescheduling';
import TabAssetSale from './tabAssetSale';
import TabCreditNoteSupplierInvoice from './TabCreditNoteSupplierInvoice';
import TabContractChangeDuration from './tabContractChangeDuration';
import TabContractChangeDueDate from './tabContractChangeDueDate';
import TabPaymentSupplierInvoice from './TabPaymentSupplierInvoice';
import TabPaymentClientInvoice from './TabPaymentClientInvoice';
import tabFinModificationReview from './tabFinModificationReview';
import TabContractReversal from './tabContractReversal';
import TabContractEndOfTerm from './tabContractEndOfTerm';
import TabContractEarlyTermination from './tabContractEarlyTermination';
import TabTPComplaint from './tabTPComplaint';
import tabUpload from './tabUpload';
import tabDecision from './tabDecision';
import tabTPAddress from './tabTPAddress';
import tabTPStatus from './tabTPStatus';
import tabTPBankAccount from './tabTPBankAccount';
import tabTPCorrespondent from './tabTPCorrespondent';
import TabAssignManager from './tabAssignManager';
import tabScoring from './tabScoring';
import tabGuaranty from './tabGuaranty';
import tabPropAssetOrdering from './tabPropAssetOrdering';
import tabAssetActivation from './tabAssetActivation';

import Button from 'components/Button';
import { request } from 'utils/request';
import { parseQueryParams } from 'utils/parseQueryParams';
import { API_URLS } from 'utils/config';
import { isArray, isNil, noop } from 'lodash';
import { FormInstance, useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import {
  customDataPrepareForApiCall,
  downloadBlobFile,
  prepareObjectForApiCall,
} from 'utils/utils2';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import TabCreatePromise from './tabCreatePromise';
import tabTPChangeAddress from './tabTPChangeAddress';
import TabMasterFacilityUse from './tabMasterFacilityUse';
import tabTPChangeBankAccount from './tabTPChangeBankAccount';
import TabProposalActivation from './tabProposalActivation';
import TabTPGeneralData from './tabTPGeneralData';
import TabPrefinActivation from './tabPrefinActivation';
import TabContractChangeBK from './tabContractChangeBK';
import TabContractChangeAddress from './tabContractChangeAddress';
import TabContractTransfer from './tabContractTransfer';
import { PropThirdPartyResponse } from 'services/proposal';
import TabCTRescheduling from './tabCTRescheduling';
import TabColDecision from './tabColDecision';
import GetLabel from 'DisplayFramework/components/GetLabel';
import TabCIPaySchedule from './tabUpdateCIPaySchedule';
import TabSIPaySchedule from './tabUpdateSIPaySchedule';
import TabColComment from './TabColComment';
import TabSplitListAsset from './tabSplitListAsset';
import TabAddAssetUse from './tabAddAssetUse';
import TabAddmarketvalue from './TabAddmarketvalue';
import TabEvaluateAsset from './TabEvaluateAsset';
import TabEvAuthorization from './tabEvTPAuthorization';
import TabTpinvestigation from './tabTpinvestigation';
import TabTpAuthorizationUse from './tabTpAuthorizationUse';
import TabSaveAssetAsCatalog from './tabSaveAssetAsCatalog';
import TabUpdateAssetGeneralData from './tabUpdateAssetGeneralData';
import TabAssetFvDuplicate from './tabAssetFvDuplicate';
import TabAssetAttributeActivation from './tabAssetAttributeActivation';
import TabParListActivation from './tabParListActivation';
import TabFinModificationRestore from './tabFinModificationRestore';
import TabSplitFinAssetOrComponent from './TabSplitFinAssetOrComponent';
import { TabUpdateTPMandateDate } from './TabUpdateTPMandateDate';
import { TabUpdateContractSignatureDate } from './TabUpdateContractSignatureDate';
import TabLoanReimbursment from './TabLoanReimbursment';
import TabLoanRescheduling from './TabLoanRescheduling';
import TabLoanEndOfTerm from './TabLoanEndOfTerm';
import TabCTPrefinancingClosure from './TabCTPrefinancingClosure';
import TabReschedulingService from './TabReschedulingService';
import TabAddTp from './tabAddTp';
import TabSplitIntialAsset from './TabSplitIntialAsset';
import ButtonOperation from 'components/ButtonOperation';
import { generateMassiveDocToPrintAndEmail } from 'services/printingService';
import FormInput from 'components/FormInput';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import TabAssetDelivery from './tabAssetDelivery';
import TabAssetServiceUseRequest from './tabAssetServiceUseRequest';
import TabpreparedAssetForDelivery from './tabpreparedAssetForDelivery';
import TabAddFinAssetFees from './tabAddFinAssetFees';
import TabAcceptPayment from 'pages/ProposalV3/Components/Modals/TabAcceptPayment';

const PRINTING_URL = API_URLS.PRINTING;

const { TabPane } = Tabs;

const funcodeToComponent: any = {
  tabCancelProposal: TabCancelProposal,
  tabRejectPayment: tabRejectPayment,
  tabCreditNoteSI: TabCreditNoteSupplierInvoice,
  tabPaymentSI: TabPaymentSupplierInvoice,
  tabPaymentCI: TabPaymentClientInvoice,
  tabFinModificationReview: tabFinModificationReview,
  tabUpload: tabUpload,
  tabDecisionEv: tabDecision,
  tabTPAddressEv: tabTPAddress,
  tabTPChangeAddress: tabTPChangeAddress,
  tabTPChangeBankAcc: tabTPChangeBankAccount,
  tabPromiseEv: TabCreatePromise,
  tabTPBankAccountEv: tabTPBankAccount,
  tabTPStatusEv: tabTPStatus,
  tabTPCorrespondentEv: tabTPCorrespondent,
  tabTPComplaintEv: TabTPComplaint,
  tabScoringEv: tabScoring,
  tabGuarantyEv: tabGuaranty,
  tabPropAssetOrdering: tabPropAssetOrdering,
  tabAssetActivation: tabAssetActivation,
  tabMasterFacilityUse: TabMasterFacilityUse,
  tabDocument: tabDocument,
  tabContractChangeDuration: TabContractChangeDuration,
  tabContractChangeDueDate: TabContractChangeDueDate,
  tabContractReversal: TabContractReversal,
  tabContractEndOfTerm: TabContractEndOfTerm,
  tabProposalActivation: TabProposalActivation,
  tabGeneralData: TabTPGeneralData,
  tabPrefinActivation: TabPrefinActivation,
  tabContractChangeBK: TabContractChangeBK,
  tabContractChangeADR: TabContractChangeAddress,
  tabContractTransfer: TabContractTransfer,
  tabCTRescheduling: TabCTRescheduling,
  tabCTEarlyTerm: TabContractEarlyTermination,
  tabContractRescheduling: TabContractRescheduling,
  tabColDecision: TabColDecision,
  tabCollectionComment: TabColComment,
  tabAssetSaleEv: TabAssetSale,
  tabUpdatePSCI: TabCIPaySchedule,
  tabUpdatePSSI: TabSIPaySchedule,
  tabSplitListAsset: TabSplitListAsset,
  tabAssignManager: TabAssignManager,
  tabAssetUse: TabAddAssetUse,
  tabAddmarketvalue: TabAddmarketvalue,
  tabEvaluateAsset: TabEvaluateAsset,
  tabEvTPAuthorization: TabEvAuthorization,
  tabTpinvestigation: TabTpinvestigation,
  tabTpAuthorizationUse: TabTpAuthorizationUse,
  tabSaveAssetAsCatalog: TabSaveAssetAsCatalog,
  tabUpdateAssetGeneralData: TabUpdateAssetGeneralData,
  tabUpdateAssetRegistrationData: TabUpdateAssetRegistrationData,
  tabAssetFvDuplicate: TabAssetFvDuplicate,
  tabAssetAttributeActivation: TabAssetAttributeActivation,
  tabParListActivation: TabParListActivation,
  tabFinModificationRestore: TabFinModificationRestore,
  tabSplitFinAssetOrComponent: TabSplitFinAssetOrComponent,
  tabUpadteDateMandat: TabUpdateTPMandateDate,
  tabUpdateSignatureDate: TabUpdateContractSignatureDate,
  tabLoanReimbursment: TabLoanReimbursment,
  TabLoanRescheduling: TabLoanRescheduling,
  tabLoanEndOfTerm: TabLoanEndOfTerm,
  tabCTPrefinancingClosure: TabCTPrefinancingClosure,
  tabServRescheduling: TabReschedulingService,
  tabAddTp: TabAddTp,
  tabSplitIntialAsset: TabSplitIntialAsset,
  tabAssetDelivery: TabAssetDelivery,
  tabAssetServiceUseRequest: TabAssetServiceUseRequest,
  tabpreparedAssetForDelivery: TabpreparedAssetForDelivery,
  tabAddFinAssetFees: TabAddFinAssetFees,
  tabSfsAcceptpay:TabAcceptPayment
};

const getUrl = (
  jobid: number | string,
  filetype: string,
  entity?: string,
  mode?: string,
  indexfile?: number
): string => {
  if (mode === 'PRINTING') {
    return `${API_URLS.PRINTING}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'PAYMENT' || mode === 'PAYMENT') {
    return `${API_URLS.PAYMENT}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'CINVOICE') {
    return `${API_URLS.CLIENT_INVOICE}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'SINVOICE') {
    return `${API_URLS.SUPPLIER_INVOICE}/api/supplier/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'COLLECTION') {
    return `${API_URLS.COLLECTION}/api/collection/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'CONFIG') {
    return `${API_URLS.CONFIGURATION_SERVICE}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'ASSETCONFIG') {
    return `${API_URLS.ASSETS_CONFIG}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else {
    if (indexfile) {
      return `${API_URLS.ACCOUNTING}/api/job/download?jobid=${jobid}&filetype=${filetype}&indexfile=${indexfile}`;
    } else {
      return `${API_URLS.ACCOUNTING}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
    }
  }
};

export type TaskModalProps = {
  tptype?: string;
  countcode?: string;
  formTP?: FormInstance;
  mgid?: number;
  entityId: number;
  entity: string;
  entityName: string;
  entityReference?: string;
  subentity?: string;
  subentityid?: number;
  onCancel: () => void;
  task: ProcTaskInit;
  visible: boolean;
  onSuccess?: any;
  random: number;
  tpid?: number;
  data?: Array<PropThirdPartyResponse>;
  dataInput?: any;
  action?: string;
  funcode?: string;
  entityList?: Array<{ entityId: number }>;
  status?: string;
  statusdate?: string;
  requestedamount?: number;
  currcode?: string;
  parcode?: string;
  parvalue?: string;
  parvalueparent?: string;
  clientName?: string;
  ctrid?: number;
};

const TaskModal = ({
  data,
  tptype,
  countcode,
  formTP,
  mgid,
  entity,
  entityId,
  entityName,
  entityReference,
  subentity,
  subentityid,
  tpid,
  onCancel,
  task,
  visible,
  dataInput,
  onSuccess = noop,
  random,
  entityList,
  status,
  statusdate,
  requestedamount,
  currcode,
  parcode,
  parvalue,
  parvalueparent,
  clientName,
  ctrid,
}: TaskModalProps) => {
  const [form] = useForm();

  const [successful, setSuccessful] = useState<boolean>(false);
  const [isFinish, setIsFinish] = useState<boolean>(false);

  const [additionalAttributeList, setadditionalAttributeList] = useState<any>();
  const [load, setload] = useState(false);
  const [activeKey, setActiveKey] = useState<string>('check');
  const params = {
    entity: entity,
    entityid: entityId,
    taskid: task.taskid ?? 0,
    subentity: task.subentity,
    subentityid: task.subentityid,
  };

  const [spinningConseq, setSpinningConseq] = useState(false);

  const {
    data: checks,
    isLoading: checkLoading,
    refetch: refetchChecks,
  } = useQuery(
    ['getTaskCheckEntity', params],
    () =>
      getTaskCheckEntity(params)
        .then((res) => {
          setload(false);
          return res.list || [];
        })
        .catch((err) => {
          setload(false);
          return [];
        }),
    {
      enabled: visible,
      /*refetchInterval: 3000,
      refetchIntervalInBackground: true,
      staleTime: Infinity,*/
    }
  );

  const { data: steps } = useQuery(
    ['getTaskStepEntity', params],
    () => getTaskStepEntity(params).then((res) => res.list || []),
    { enabled: visible }
  );

  const hasFailedChecks =
    checks?.find((check) => check.controlCheck === false) !== undefined;

  const {
    data: consequences,
    refetch: refetchConsequences,
    isFetching,
    isRefetching,
  } = useQuery(
    ['getTaskConseqEntity', params],
    () => getTaskConseqEntity(params).then((res) => res.list ?? undefined),
    {
      enabled: !hasFailedChecks && visible,
      refetchInterval: 3000,
      refetchIntervalInBackground: true,
      staleTime: Infinity,
    }
  );

  const firstStep = steps && steps.length > 0 && steps[0];

  const ExtraStepComponent = firstStep && funcodeToComponent[firstStep.funcode];

  useEffect(() => {
    if (hasFailedChecks) {
      setActiveKey('check');
    } else if (firstStep) {
      setActiveKey('extra-step');
    } else {
      setActiveKey('consequences');
    }
  }, [hasFailedChecks, firstStep]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const [url, paramsString] = task.serviceurl
          ? task.serviceurl.split('?')
          : ''.split('?');
        setload(true);
        request
          .post(`${API_URLS.WORKFLOW}/api/${url}`, {
            ...parseQueryParams(paramsString),
            entityId,
            entity: entity,
            taskid: task?.taskid,
            subentity: task?.subentity,
            subentityid: task?.subentityid,
            objectreference: entityReference,
            ...prepareObjectForApiCall(form.getFieldsValue()),
            ...customDataPrepareForApiCall(
              form.getFieldsValue(),
              entity,
              entityId,
              entityReference,
              form
            ),
            entityAddAttributList: additionalAttributeList ?? [],
          })
          .then((res) => {
            if (res.success) {
              notification.success({ message: res.message });
              setIsFinish(true);
              refetchConsequences();
              onSuccess();
              setload(false);
            } else {
              setload(false);
              return Promise.reject(res);
            }
          })
          .catch((res) => {
            try {
              let errormsg: any;
              if (res.message && !isNil(res.message) && res.message !== '') {
                let listError = JSON.parse(res.message);
                if (isArray(listError)) {
                  errormsg = React.createElement(
                    'table',
                    { className: 'styled-table' },
                    null,
                    React.createElement(
                      'thead',

                      null,
                      React.createElement(
                        'tr',
                        { className: 'active-row' },
                        React.createElement(
                          'th',

                          null,
                          'Code'
                        ),
                        React.createElement(
                          'th',

                          null,
                          'Message'
                        )
                      )
                    ),

                    listError.map((error: any) => {
                      return React.createElement(
                        'tr',
                        { className: 'active-row' },
                        React.createElement(
                          'td',
                          { style: { fontWeight: '700' } },
                          error.ccode
                        ),
                        React.createElement(
                          'td',

                          null,
                          error.message
                        )
                      );
                    })
                  );

                  notification.error({
                    description: errormsg,
                    message: React.createElement(
                      'span',
                      { style: { fontWeight: '700', color: '#660000' } },
                      'Functional Controls'
                    ),
                    className: 'error417',
                    style: {
                      width: 400,
                      padding: '9px 12px 1px 12px',
                      marginLeft: 0,
                    },
                  });
                } else {
                  errormsg = listError;
                  notification.error({
                    message: errormsg,
                  });
                }
              }

              return Promise.reject(res);
            } catch (Exception) {
              notification.error({ message: res.message });
            }
            setload(false);
          });
      })
      .catch((e) => {
        onFinishFailed(e);
      });
    //;
  };

  const generateMassiveDocToPrint = () => {
    let listToGenerateMassiveDoc: any[] = [];

    const printAllInOne = form.getFieldValue('flagEditAllInOne') ?? false;
    setSpinningConseq(true);

    consequences?.forEach((item) => {
      if (item.conseqtype === 'PRINT') {
        listToGenerateMassiveDoc.push({
          doccode: item.conseqcode,
          conseqid: item.conseqid,
          notifid: item.notifid,
          entityid: item.entityid,
          entity: item.entity,
          subentity: item.subentity ?? '',
          subentityid: item.subentityid ?? 0,
          flagEmail: false,
          emailTo: item.emailtotarget,
          emailCc: item.emailcctarget,
          printid: item.printid,
        });
      }
    });

    if (listToGenerateMassiveDoc.length > 0) {
      generateMassiveDocToPrintAndEmail({
        docToPrintAndEmailResponses: listToGenerateMassiveDoc,
        execMode: 'DB',
        printAllInOne: printAllInOne,
        kafkaEnabled: 'false',
      })
        .then(async (res: any) => {
          if (printAllInOne === true) {
            const globalDocObject = res.list[res.list.length - 1];
            setSpinningConseq(true);

            await downloadBlobFile(
              res.list[res.list.length - 1].outputfile,
              getUrl(globalDocObject.jobid, 'OUTPUT', entity, 'PRINTING', 0)
            )
              .then(() => {
                setSpinningConseq(false);
              })
              .catch(() => {
                setSpinningConseq(false);
              });
          } else {
            await getTaskConseqEntity(params)
              .then(async (res) => {
                await Promise.all(
                  res.list.map((item) => {
                    setSpinningConseq(true);
                    if (item.conseqtype === 'PRINT') {
                      return downloadBlobFile(
                        `${item.conseqcode}-${item.entity}-${item.entityid}-${item.conseqid}.pdf`,
                        `${PRINTING_URL}/api/print/download?printid=${item.printid}`
                      );
                    }
                  })
                )
                  .then(() => {
                    setSpinningConseq(false);
                  })
                  .catch(() => {
                    setSpinningConseq(false);
                  });
              })
              .catch((err) => {
                setSpinningConseq(false);
              });
          }
        })
        .catch(() => {
          setSpinningConseq(false);
        });
    } else {
      setSpinningConseq(false);
    }
  };

  return (
    <DF.Provider pagcode="taskmodal" entity={entity} entityid={entityId}>
      <Form form={form ?? formTP} preserve={false}>
        <Modal className='ut-task-modal'
          destroyOnClose
          afterClose={() => {
            // Modal.destroyAll();
            // form.resetFields();
            setSuccessful(false);
          }}
          open={visible}
          onCancel={() => {
            setSuccessful(false);
            onCancel();
          }}
          width={1800}
          // forceRender
          title={
            <>
              <GetLabel
                label={task.tasklabel + ' - '}
                Inspectstyle={{ width: '98%' }}
              />

              {entityName}
            </>
          }
          style={{ top: 20 }}
          footer={
            <div style={{ background: 'wihte' }}>
              <Row justify="center" style={{ width: '100%', marginBottom: 7 }}>
                <Button style={{ height: 52, width: '100%' }} key="cancel" comcode="cancel" onClick={onCancel} />
              </Row>
              <Row justify="center" style={{ width: '100%' }}>
                <Button
                  key="ok"
                  comcode="ok"
                  type="primary"
                  disabled={isFinish || successful || hasFailedChecks}
                  loading={load}
                  onClick={() => {
                    form.submit();
                    handleOk();
                  }}
                  style={{ height: 52, width: '100%' }}
                />
              </Row>
            </div>
          }
        >
          <Spin spinning={load || checkLoading}>
            <Card bordered className="WF_card">
              <Tabs
                onChange={(e) => {
                  setActiveKey(e);
                }}
                activeKey={activeKey}
                tabBarExtraContent={
                  <Row gutter={10}>
                    {hasFailedChecks && (
                      <Col>
                        <Alert
                          message={<GetLabel label="FailedChecks" />}
                          type="error"
                          showIcon
                        />
                      </Col>
                    )}

                    {consequences &&
                      consequences?.filter(
                        (e) =>
                          e?.conseqtype === 'PRINT' && e?.conseqstatus !== ''
                      )?.length > 1 && (
                        <>
                          <Col>
                            <FormInput
                              name="flagEditAllInOne"
                              initialValue="false"
                            >
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                              />
                            </FormInput>
                          </Col>
                          <Col>
                            <ButtonOperation
                              htmlType="button"
                              comcode={
                                consequences.filter(
                                  (e) =>
                                    e?.conseqtype === 'PRINT' &&
                                    e?.conseqstatus === 'CLOSED'
                                ).length === 0
                                  ? 'execAll_And_download'
                                  : 'runagain_execAll_And_download'
                              }
                              onClick={() => {
                                generateMassiveDocToPrint();
                              }}
                              loading={spinningConseq}
                            />
                          </Col>
                        </>
                      )}
                  </Row>
                }
              >
                {firstStep && (
                  <TabPane tab={firstStep.steplabel} key="extra-step">
                    {ExtraStepComponent && (
                      <ExtraStepComponent
                        clientName={clientName}
                        data={data}
                        dataInput={dataInput}
                        objectid={entityId}
                        tpid={tpid}
                        ctrid={ctrid}
                        object={entity}
                        subentity={subentity}
                        subentityid={subentityid}
                        form={form}
                        mgid={mgid}
                        formTP={formTP}
                        tptype={tptype}
                        countcode={countcode}
                        entityReference={entityReference}
                        entityList={entityList}
                        status={status}
                        statusdate={statusdate}
                        requestedamount={requestedamount}
                        currcode={currcode}
                        entityName={entityName}
                        setSuccessful={setSuccessful}
                        parcode={parcode}
                        parvalue={parvalue}
                        parvalueparent={parvalueparent}
                        setadditionalAttributeList={setadditionalAttributeList}
                      />
                    )}
                  </TabPane>
                )}
                <TabPane tab={<GetLabel label="Check" />} key="check">
                  <Check
                    checks={checks}
                    onSuccess={refetchChecks}
                    entityReference={entityReference}
                  />
                </TabPane>
                {!hasFailedChecks && (
                  <TabPane
                    tab={<GetLabel label="Consequences" />}
                    key="consequences"
                  >
                    <Spin
                      spinning={spinningConseq || (isFetching && !isRefetching)}
                    >
                      <Consequences
                        consequences={consequences}
                        entityReference={entityReference}
                      />
                    </Spin>
                  </TabPane>
                )}
              </Tabs>
            </Card>
          </Spin>
        </Modal>
      </Form>
    </DF.Provider>
  );
};

export default TaskModal;
